import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { getProjectFiles } from '@queries'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useProjectFiles = <T extends Record<string, any> = Record<string, any>>(rootGuid: string) => {
  const { projectId } = useParams()

  const {
    data = {
      files: [],
      sections: [],
    },
    isFetching,
    // Only the first load, not background refetches
    isLoading,
  } = useQuery<FilesResult<T>>({
    queryKey: getProjectFiles.getKey(projectId, rootGuid),
    queryFn: async () => {
      const documentsResponse = await getProjectFiles.request(projectId, rootGuid)

      return documentsResponse
    },
    refetchOnMount: true,
  })

  return { data, isFetching, isLoading }
}

export default useProjectFiles
